import { Get, GetCardInfo, Post, PostJuspay, Put } from 'api';

import { API_URL } from './CONSTANT';
import {
	IPaymentModesResponse,
	ISendPaymentModesResponse,
	IGenerateOtpResponse,
	IPaymentStatusResponse,
	ISampleResponse,
	rzpCardInfoResponse,
} from 'types';
import { globalId } from '../index';
import { getURLParameter } from 'utils/nativeSupport';

/**
 * Sample API
 */

// For Getting Payment Modes
export const GetPaymentModesDetail = async (id: any): Promise<IPaymentModesResponse> => {
	return Get<IPaymentModesResponse>(`${API_URL.payment_mode}${id}/method`);
};
// For Getting Payment Details - https://demo1154293.mockable.io/postPayment
export const SendPaymentModesDetail = async (payload: any): Promise<ISendPaymentModesResponse> => {
	return Post<ISendPaymentModesResponse>(`${API_URL.payment_mode}${globalId}/method`, { payload });
};
// For Getting JUSPAY Payment Modes V2
export const GetJuspayPaymentModes = async (payload: any): Promise<ISampleResponse> => {
	return Get<ISampleResponse>(`${API_URL.getPaymentModesV2}${globalId}/method/${payload?.checkout}`);
};
// For Getting JUSPAY Web Payment Modes V2
export const GetJuspayWebPaymentModes = async (payload: any): Promise<ISampleResponse> => {
	// const isDummyData = getURLParameter(window.location.href, 'isDummyData') || '';
	// if (isDummyData) {
	// 	return Get<ISampleResponse>('https://demo1154293.mockable.io/getPaymentModes');
	// }
	return Get<ISampleResponse>(`${API_URL.getPaymentModesV2}${globalId}/method/webview/${payload?.checkout}`);
};
// For doing FP mode txn and retrying with JUSPAY modes
export const PostJuspayFpAndOtherModes = async (payload: any): Promise<ISampleResponse> => {
	return PostJuspay<ISampleResponse>(
		`${API_URL.getPaymentModesV2}${globalId}/method/${payload?.checkout}`,
		payload?.request,
	);
};
// For Updating Cashback details JUSPAY
export const UpdateJuspayCashback = async (payload: any): Promise<ISampleResponse> => {
	return Post<ISampleResponse>(`${API_URL.getPaymentModesV2}${globalId}/update`, payload);
};
// Get Request for Payment Status Details
export const GetPaymentStatusDetails = async (id: string): Promise<IPaymentStatusResponse> =>
	Get<IPaymentStatusResponse>(`${API_URL.payment_status}${id}`);

// Generate Otp
export const GenerateOtpDetails = async (payload: any): Promise<IGenerateOtpResponse> => {
	return Post<IGenerateOtpResponse>(`${API_URL.verify_otp}`, { ...payload });
};

// Resend Otp
export const ResendOtpDetails = async (payload: any): Promise<IGenerateOtpResponse> => {
	return Post<IGenerateOtpResponse>(`${API_URL.resend_otp}`, { ...payload });
};

// For Getting Payment Details
export const CancelPaymentApi = async (payload: any): Promise<ISendPaymentModesResponse> => {
	return Post<ISendPaymentModesResponse>(`${API_URL.payment_mode}cancel`, { ...payload });
};

// Get Request for postpe cashback details
export const GetPostpeCashbackDetails = async (id: string): Promise<ISampleResponse> =>
	Get<ISampleResponse>(`${API_URL.get_cashback}?orderId=${id}`);

// For applying/unnapply postpe cashback
export const SendPostpeCashbackConfirmation = async (payload: any): Promise<ISampleResponse> => {
	return Put<ISampleResponse>(`${API_URL.toggle_postpe_cashback}`, { ...payload });
};

// Get Request for card info based on IIN
export const GetCardInfoFromIIN = async (iin: string | number): Promise<rzpCardInfoResponse> =>
	GetCardInfo<any>(`${API_URL.get_card_info}?iin=${iin}`);
